// CommonJS format instead of ES6 modules
const ACCESS_TYPE = 'ws'; // ws or sse 标志链接方式
const APP_KEY = "";

// Welcome message configuration
const configs = {
    // Default welcome message
    default: {
        serverPath: 'zb.chat-notary.com/api',
        title: '上海市闸北公证处',
        subtitle: '请问您想办理何种公证？<br>选择后将告知您所需材料。',
        clientId: 'zhabei',
        avatar: 'https://qidian-qbot-1251316161.cos.ap-guangzhou.myqcloud.com/public/1942556148986959424/1942557522504078912/image/xFmciLhjAFCGiSjuTtBe-1982302655619147520.png',
        bgEnabled: true,
        questionTree: [
            {
                name: '民事公证',
                children: [
                    { name: '继承公证' },
                    { name: '遗嘱公证' },
                    { name: '委托公证' },
                    {
                        name: '合同协议类公证（专题集合）',
                        children: [
                            { name: '买卖合同公证' },
                            { name: '赠与合同公证' },
                            { name: '婚前财产约定公证' },
                            { name: '夫妻财产约定公证' },
                            { name: '财产分割协议公证' },
                            {
                                name: '金融合同公证（专题集合）',
                                children: [
                                    { name: '贷款合同公证' },
                                    { name: '最高额授信合同公证' },
                                    { name: '最高额抵押合同' },
                                    { name: '抵押合同公证' },
                                    { name: '保证合同公证' }
                                ]
                            },
                            { name: '监护/收养协议公证' }
                        ]
                    },
                    { name: '资金监管/提存公证' },
                    { name: '签名/印鉴公证' },
                    { name: '知识产权证明公证' },
                    { name: '证据保全公证' },
                    { name: '声明书类公证' }
                ]
            },
            {
                name: '商事公证',
                children: [
                    { name: '公司章程公证' },
                    { name: '营业执照公证' },
                    {
                        name: '金融合同公证（专题集合）',
                        children: [
                            { name: '贷款合同公证' },
                            { name: '最高额授信合同公证' },
                            { name: '最高额抵押合同' },
                            { name: '抵押合同公证' },
                            { name: '保证合同公证' }
                        ]
                    },
                    { name: '资质公证' },
                    { name: '股权更名/转让公证' },
                    { name: '法人/法定代表人资格公证' },
                    { name: '财务证明文件公证' },
                    { name: '知识产权证明公证' },
                    { name: '签名/印鉴公证' },
                    { name: '现场监督公证' },
                    { name: '资金监管/提存公证' },
                    { name: '证据保全公证' },
                    { name: '执行证书' }
                ]
            },
            {
                name: '涉外公证',
                children: [
                    { name: '无犯罪记录公证' },
                    { name: '学历/学位/成绩单公证' },
                    { name: '亲属关系公证' },
                    { name: '出生/出生证公证' },
                    { name: '死亡/死亡证公证' },
                    { name: '结婚/结婚证/离婚公证' },
                    { name: '身份证公证' },
                    { name: '护照公证' },
                    { name: '户籍/户口簿公证' },
                    { name: '国籍公证' },
                    { name: '住所地公证' },
                    { name: '职务/职称公证' },
                    { name: '经历公证' },
                    { name: '驾驶证/职业资格公证' },
                    { name: '判决书/仲裁书公证' },
                    { name: '译本与文本/副本与原本相符公证' }
                ]
            },
            {
                name: '其他问题',
                children: [
                    { name: '可以线上办理公证吗？' },
                    { name: '可以做远程视频公证吗？' },
                    { name: '如何确定法定继承人的范围？' },
                    { name: '如何获取单位人事档案/银行清单等常见材料？' },
                    { name: '如何进行房屋车辆变更登记？' },
                    { name: '如何办理附加证明书（海牙认证）？' },
                    { name: '办理公证需要多久？' },
                    { name: '公证费用如何收取？' },
                    { name: '公证处的地址与联系方式' }
                ]
            }
        ]
    },
    local: {
        serverPath: 'zb.chat-notary.com/api',
        title: '上海市闸北公证处',
        subtitle: '请问您想办理何种公证？<br>选择后将告知您所需材料。',
        clientId: 'zhabei',
        avatar: 'https://qidian-qbot-1251316161.cos.ap-guangzhou.myqcloud.com/public/1942556148986959424/1942557522504078912/image/xFmciLhjAFCGiSjuTtBe-1982302655619147520.png',
        bgEnabled: true,
        questionTree: [
            {
                name: '民事公证',
                children: [
                    { name: '继承公证' },
                    { name: '遗嘱公证' },
                    { name: '委托公证' },
                    {
                        name: '合同协议类公证（专题集合）',
                        children: [
                            { name: '买卖合同公证' },
                            { name: '赠与合同公证' },
                            { name: '婚前财产约定公证' },
                            { name: '夫妻财产约定公证' },
                            { name: '财产分割协议公证' },
                            {
                                name: '金融合同公证（专题集合）',
                                children: [
                                    { name: '贷款合同公证' },
                                    { name: '最高额授信合同公证' },
                                    { name: '最高额抵押合同' },
                                    { name: '抵押合同公证' },
                                    { name: '保证合同公证' }
                                ]
                            },
                            { name: '监护/收养协议公证' }
                        ]
                    },
                    { name: '资金监管/提存公证' },
                    { name: '签名/印鉴公证' },
                    { name: '知识产权证明公证' },
                    { name: '证据保全公证' },
                    { name: '声明书类公证' }
                ]
            },
            {
                name: '商事公证',
                children: [
                    { name: '公司章程公证' },
                    { name: '营业执照公证' },
                    {
                        name: '金融合同公证（专题集合）',
                        children: [
                            { name: '贷款合同公证' },
                            { name: '最高额授信合同公证' },
                            { name: '最高额抵押合同' },
                            { name: '抵押合同公证' },
                            { name: '保证合同公证' }
                        ]
                    },
                    { name: '资质公证' },
                    { name: '股权更名/转让公证' },
                    { name: '法人/法定代表人资格公证' },
                    { name: '财务证明文件公证' },
                    { name: '知识产权证明公证' },
                    { name: '签名/印鉴公证' },
                    { name: '现场监督公证' },
                    { name: '资金监管/提存公证' },
                    { name: '证据保全公证' },
                    { name: '执行证书' }
                ]
            },
            {
                name: '涉外公证',
                children: [
                    { name: '无犯罪记录公证' },
                    { name: '学历/学位/成绩单公证' },
                    { name: '亲属关系公证' },
                    { name: '出生/出生证公证' },
                    { name: '死亡/死亡证公证' },
                    { name: '结婚/结婚证/离婚公证' },
                    { name: '身份证公证' },
                    { name: '护照公证' },
                    { name: '户籍/户口簿公证' },
                    { name: '国籍公证' },
                    { name: '住所地公证' },
                    { name: '职务/职称公证' },
                    { name: '经历公证' },
                    { name: '驾驶证/职业资格公证' },
                    { name: '判决书/仲裁书公证' },
                    { name: '译本与文本/副本与原本相符公证' }
                ]
            },
            {
                name: '其他问题',
                children: [
                    { name: '可以线上办理公证吗？' },
                    { name: '可以做远程视频公证吗？' },
                    { name: '如何确定法定继承人的范围？' },
                    { name: '如何获取单位人事档案/银行清单等常见材料？' },
                    { name: '如何进行房屋车辆变更登记？' },
                    { name: '如何办理附加证明书（海牙认证）？' },
                    { name: '办理公证需要多久？' },
                    { name: '公证费用如何收取？' },
                    { name: '公证处的地址与联系方式' }
                ]
            }
        ]
    }
};

function getSubdomain() {
    // if localhost, return local
    if (window.location.hostname === 'localhost') {
        return 'default';
    }
    const hostnameParts = window.location.hostname.split('.');
    // Assumes structure is subdomain.domain.tld or subdomain.app.domain.tld
    // If your domain structure is different, adjust this logic.
    if (hostnameParts.length > 2) {
        return hostnameParts[0];
    }
    return 'default'; // Or whatever your main app's identifier is
}

const subdomain = typeof window !== 'undefined' ? getSubdomain() : 'default';

// Export the configuration for the current subdomain, or the default
const config = configs[subdomain] || configs.default;
// CommonJS exports instead of ES6 exports
module.exports = {
    ACCESS_TYPE,
    APP_KEY,
    config
};



// WEBPACK FOOTER //
// ./src/constants/static.js